<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header"><span v-if="(this.benefitclaimMenu=='hrm.benefitclaimself')">My</span><span v-else>Employee</span> Benefit Claim   
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <b-button variant="btn btn-primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="btn btn-primary mr-1" @click="deleteConfirm">Delete</b-button>
          <b-button variant="primary mr-1" @click="approvalConfirm()" v-if="(this.benefitclaimMenu=='hrm.benefitclaimself')"><i class="fa fa-paper-plane"></i> Approval</b-button>
          <b-button variant="primary mr-1" @click="print()" ><i class="fa fa-print"></i> Print Form</b-button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="4" >
            <b-input-group >
              <b-input-group-prepend><label style="width:80px !important;">Claim Date</label></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
              <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
            </b-input-group>
        </b-col>
        <b-col lg="6">
              <b-row>
                <b-col lg="6">
                    <b-input-group >
                      <b-input-group-prepend><label style="width:100px !important;">Employee/Crew</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.crewname" :disabled="(this.benefitclaimMenu=='hrm.benefitclaimself')"></b-form-input>
                        <b-input-group-append v-if="(this.benefitclaimMenu!='hrm.benefitclaimself')">
                        <b-btn text="Button" @click="lkuCrewShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
                <b-col cols="6">
                  <b-input-group>
                      <b-input-group-prepend><label>Benefit Name</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.NmClaim" ></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuBenefitShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                  </b-input-group>                  
                </b-col>
              </b-row>                      
        </b-col>
        <b-col lg="2">
              <b-row  class="justify-content-center">
                <b-button class="btn btn-success ml-1 mr-1" @click="search()" size="sm"> <i class="fa fa-refresh"></i> Apply Filter</b-button>
                <b-button class="btn btn-secondary" @click="clearFilter()" size="sm"> <i class="fa fa-eraser"></i>Clear Filter</b-button>
              </b-row>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover 
        style="font-size:smaller;" 
        :items="data"
        :fields="tblData.fields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit" @row-clicked="rowClicked"
      >

        <template v-slot:cell(TakenDate)="data">
          {{data.item.TakenDate | moment('YYYY-MMM-DD')}}
        </template>
        <template v-slot:cell(TotalClaim)="data">
          {{data.item.TotalClaim | numFormat}}
        </template>
        <template v-slot:cell(TakenAmount)="data">
          {{data.item.TakenAmount | numFormat}}
        </template>
        <template v-slot:cell(issuccess)="data">
          <status-aprroval :dataStatus="data.item"></status-aprroval>  
        </template>

      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page" class="mb-0">
            <b-form-select :options="[10, 15, 20, 25, 30, 35,40,45,50]" :plain="true" v-model="tblData.limit"  style="width:80px;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
              <b-pagination
                align="right"
                v-if="pagination" 
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
      <b-modal v-model="lkuCrewShow" size="lg" :hide-footer="true" title="List of Employee" :centered="true">
          <lku-crew @click="onSelectLkuCrew"></lku-crew>
      </b-modal>        
      <b-modal v-model="lkuBenefitShow" size="lg" :hide-footer="true" title="List of Employee Benefit" :centered="true" :lazy="true">
          <lku-benefit @click="onSelectLkuBenefit" ></lku-benefit>
      </b-modal>      

      <b-modal v-model="showApprovalConfirm" header-bg-variant="primary"  title="Approval Form" size="lg" :centered="true" hide-footer>
          <b-row>
              <b-col md="5">
                  <b-input-group>
                      <b-input-group-prepend><label>Claim Number</label></b-input-group-prepend>
                      <b-form-input v-model="terpilih.nomor" readonly></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col md="4">                            
                  <b-input-group>
                      <b-input-group-prepend><label>Claim Date</label></b-input-group-prepend>
                      <b-form-input :value="terpilih.TakenDate | moment('ddd, DD-MMM-YYYY')"  disabled></b-form-input>                                        
                  </b-input-group>
              </b-col>
          </b-row >  
          <b-input-group >
              <b-input-group-prepend><label>Description</label></b-input-group-prepend>
              <b-form-input v-model="terpilih.TakenReason"  readonly></b-form-input>
          </b-input-group>
          <div v-if="(this.terpilih.send2wf==1)">
            <label>Workflow process history</label>
            <div class="report-wraper">
                <table width="100%">
                <thead>
                <tr>
                <th width="120px">Assign Date</th>
                <th width="220px">Assign To</th>
                <th width="80px">Action Take</th>
                <th >Comment</th>
                <th width="120px">Complete Date</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="row in approvalHistory" :key="row.taskassignkey">
                  <td> {{row.assignstr | moment("dddd , DD-MMM-YYYY hh:mm:ss")}} </td>
                  <td>{{row.crewnik}} | {{row.crewname}}</td>
                  <td>{{row.actiontake}} 
                      <p v-if="(row.crewname !== row.actionBy)">{{row.actionBy}}</p></td>
                  <td>{{row.message}}</td>
                  <td><span v-if="(row.completeddate)">{{row.completeddate | moment("ddd, DD-MMM-YYYY hh:mm:ss")}}</span></td>
                  </tr>
                  <tr> <td colspan="5" class="subtotal"></td></tr>
                  </tbody>
                  </table>
              </div>
              <b-row class="justify-content-center mt-1" >
                  <b-button variant="primary" @click="printApproval"><i class="fa fa-print"></i> Print Approval</b-button>
                  <b-button v-if="((terpilih.iscomplete==0) || (terpilih.isreject==1))" variant="danger" class="ml-1" @click="showApprovalCancelConfirm=true" > <i class="fa fa-undo"></i> Cancel Approval</b-button>
                  <b-button variant="secondary" class="ml-1" @click="showApprovalConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
              </b-row>
          </div>
          <div no-body v-else>
            <label>Add Attachment</label>
              <b-form-file
              v-model="file"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              ></b-form-file>
              <div class="mt-3" >Selected file: <strong>{{ file ? file.name : '' }}</strong></div>   
              <b-row class="justify-content-center mt-1" v-if="(showConfirmNoFile)">
                  <label style="width:260px !important;">Send without attachment, are you sure?</label>
                    <b-form-radio-group  v-model="confirmNoFile"  class="ml-1" >
                        <b-form-radio :value="true">Yes</b-form-radio>
                        <b-form-radio :value="false">No</b-form-radio>
                    </b-form-radio-group>
              </b-row>
              <b-row class="justify-content-center mt-1" >
                  <b-button variant="primary" @click="approval"><i class="fa fa-paper-plane"></i> Send to Workflow</b-button>
                  <b-button variant="secondary" class="ml-1" @click="showApprovalConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
              </b-row>
          </div>
      </b-modal>
      <b-modal v-model="showApprovalCancelConfirm" title="Remove from workflow Approval Process?" :centered="true" @ok="approvalUndo">
        <p class="mb-1">The selected a row of data will be removed from Workflow?</p>
      </b-modal>

      <b-modal v-model="showAttachment" header-bg-variant="primary"  title="Claim Attachment" size="lg" :centered="true" ok-only>
          <b-row>
              <b-col md="5">
                  <b-input-group>
                      <b-input-group-prepend><label>Claim Number</label></b-input-group-prepend>
                      <b-form-input v-model="terpilih.nomor" readonly></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col md="4">                            
                  <b-input-group>
                      <b-input-group-prepend><label>Claim Date</label></b-input-group-prepend>
                      <b-form-input :value="terpilih.TakenDate | moment('ddd, DD-MMM-YYYY')"  disabled></b-form-input>                                        
                  </b-input-group>
              </b-col>
          </b-row >  
          <b-input-group >
              <b-input-group-prepend><label>Description</label></b-input-group-prepend>
              <b-form-input v-model="terpilih.TakenReason"  readonly></b-form-input>
          </b-input-group>
            <div class="report-wraper">
              <table width="100%">
                <thead>
                  <tr>
                    <th width="200px">Attached Date</th>
                    <th >File Name</th>
                    <th width="100px">Attached By</th>
                    <th width="40px">action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in attachmens" :key="row.attachmentKey">
                    <td> {{row.modified | moment("dddd , DD-MMM-YYYY hh:mm:ss")}} </td>
                    <td>                                
                        <b-link @click="attachmentDownload(row)">{{row.attchFileNm}}</b-link>
                    </td>
                    <td>{{row.createby}}</td>
                    <td>                                
                      <div class="text-center" v-if="(terpilih.iscomplete==0)">
                      <a href="javascript:void(0)" class="text-danger" @click="delAttachment(row)">
                          <i class="fa fa-trash"></i>
                      </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          <div no-body v-if="(terpilih.iscomplete==0)">
            <label>Add Attachment</label>
              <b-form-file
              v-model="file"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              ></b-form-file>
              <b-row class="mt-1" >
                  <span class="p-2" >Selected file: <strong>{{ file ? file.name : '' }}</strong></span>   
                  <b-button variant="success" @click="attachmentSave" class="sm" v-if="(file)"><i class="fa fa-paperclip"></i> Add Attachment</b-button>
              </b-row>
          </div>
      </b-modal>

  </div>
</template>

<style lang="scss">

    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import benefitclaim from "../../apis/benefitclaim";
import task from "../../apis/task";
import lkuCrew from "../lookup/lkuCrew";
import lkuBenefit from '../lookup/lkuBenefit';

import toastr from "mini-toastr";
toastr.init();

export default {
  components: {Loading,lkuCrew,lkuBenefit},
  data() {
    return {
      showAttachment: false, 
      attachmens:[],
      showFilter: false,
      showDelConfirm: false,
      showApprovalConfirm: false,
      approvalHistory:[],
      file:null,
      confirmNoFile:false,
      showConfirmNoFile:'',
      showApprovalCancelConfirm: false,

      benefitclaimMenu:'',
      user: this.$store.state.user,
      showDelConfirm: false,
      lkuBenefitShow: false,
      lkuCrewShow:false,
      showFilter:false,
      isLoading:false,
      showReport:false,
      reportUrl: `${location.origin}/#load`,
      terpilih:{ClaimHistID:''},
      pagination:false,
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        outstand: '1',
        fields:[
          { key: 'nomor', 
            label: 'Claim No.',             
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          { key: 'TakenDate', 
            label: 'Claim Date',             
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "crewinfo",
            label: "Employee",
            sortable: true
          },
          {
            key: "jabatan",
            label: "Job Title",
            sortable: true
          },
          {
            key: "departemen",
            label: "Department",
            sortable: true
          },
          {
            key: "locationname",
            label: "Location",
            sortable: true
          },
          {
            key: "NmClaim",
            label: "Benefit Name",
            sortable: true
          },
          {
            key: "Periode",
            label: "Entitlement Period",
          },
          {
            key: "TakenReason",
            label: "Claim Description",
            sortable: true
          },
          {
            key: "TotalClaim",
            label: "Claim Requested Amt.",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "TakenAmount",
            label: "Claim Approved Amt.",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "issuccess",
            label: "Approval Status",
            thStyle: "width:60px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
        ]
      }
    };
  },
  created: async function() {
    localStorage.setItem("benefitclaimMenu", this.$route.name);
    this.benefitclaimMenu=this.$route.name;
    if (this.benefitclaimMenu=="hrm.benefitclaimself")  {
        this.tblData.crewkey=this.user.crewkey;
        this.tblData.crewname=this.user.full_name;
        this.tblData.crewnik=this.user.crewnik;
    }
  },
  methods: {
    onSelectLkuCrew: async function (_selected) {
        this.tblData.crewkey=_selected.crewkey;
        this.tblData.crewname=_selected.crewname;
        this.tblData.crewnik=_selected.crewnik;
        this.lkuCrewShow=false;
    },    
    onSelectLkuBenefit: function(_selected){
        this.tblData.ClaimID =_selected.ClaimID;
        this.tblData.NmClaim =_selected.NmClaim;
        this.lkuBenefitShow=false;
    },    
    data: async function() {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.benefiCmList) {
            this.tblData[key] = filter.benefiCmList[key];
            filtered=true;
        }
        if (filtered === true) {
          this.tblData.tgl1=filter.benefiCmList.tgl1 || '';
          this.tblData.tgl2=filter.benefiCmList.tgl2 || '';

          this.showFilter=filtered;
          delete filter.benefiCmList;
          this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=true; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await benefitclaim.list(this.tblData);
                  this.pagination=true;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
                }
            }
        } else {
            this.isLoading=true;
            this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
            try {
              const list = await benefitclaim.list(this.tblData);
              this.pagination=true;
              this.isLoading=false;  
              return list;        
            } catch (error) {
              this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
            }
        }
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.crewname = '';
        this.tblData.crewnik =  '';
        this.tblData.outstand =  '';
        this.refresh();
    },
    saveFilter() {
      const keys = ['tgl1', 'tgl2', 'crewnik', 'crewname', 'crewkey', 'ClaimID', 'NmClaim','outstand'];
      let filtered = false;
      const benefiCmList={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              benefiCmList[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          benefiCmList.page=this.tblData.page;
          benefiCmList.limit=this.tblData.limit;
          benefiCmList.sortBy=this.tblData.sortBy;
          benefiCmList.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.benefiCmList=benefiCmList;
          console.log('filter.benefiCmList: ', benefiCmList);
          this.$store.commit("filter", filter);
      } 
    },    

    add: function() {
       this.saveFilter();
       router.push({name: 'hrm.benefitclaimfrm'});
    },
    edit: function() {
      if (this.terpilih.ClaimHistID) {
        this.saveFilter();
        router.push({name: 'hrm.benefitclaimfrm', params: { ClaimHistID: this.terpilih.ClaimHistID}});
      } else {
            toastr.warn('Please select a row that want to be Edit!');
      }
    },
    deleteConfirm() {
      if (this.terpilih.ClaimHistID) {
        this.showDelConfirm = true;
      } else {
            toastr.warn('Please select a row that want to be Deleted!');
      }
    },
    deleteData: async function() {
          try {
            await benefitclaim.remove(this.terpilih);
            this.refresh();
          } catch (error) {
                if (error.message) {
                    toastr.error(error.message,'Error Info',10000);
                } else {
                    toastr.error(JSON.stringify(error),'Error Info',10000);
                }        
          }
    },
    rowClicked(record, index) {
      // if (this.terpilih.ClaimHistID==record.ClaimHistID) {
      //   console.log('terpilih row click: ', this.terpilih);
      //   this.edit();
      // } else {
        if ((this.terpilih) && (this.terpilih._rowVariant)) {
            delete this.terpilih._rowVariant;
        }
        this.terpilih = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
      // }
    },

    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await benefitclaim.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message, 'Error Info',10000);
            } else {
                toastr.error(JSON.stringify(error), 'Error Info',10000);
            }
        }
    },
    close(){
      router.push("/payroll/home");
    },    
    print: async function()
    {
      if (this.terpilih.ClaimHistID) {
          try {
              this.reportUrl= await benefitclaim.print(this.terpilih);
              if (this.$isMobile()){
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              } else {
                this.showReport=true;
              }
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },

    getAttachment: async function(record) {
      try {
        this.terpilih=record;
        // this.terpilih.TakenDate = this.terpilih.TakenDate ? moment(this.terpilih.TakenDate).format('YYYY-MM-DD') : '';
        this.isLoading=true;
        const data = await task.getAttachment({taskkey: record.ClaimHistID});
        this.attachmens=data;    
        this.showAttachment=true;            
        this.isLoading=false;
      } catch (error) {
        this.isLoading=false;
        console.log('error : ', error);
        if (error.sql) {
            toastr.error(error.sql,'ERROR MESSAGE',10000);
        } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
        } else if (error.message) {
            toastr.error(error.message,'ERROR MESSAGE',10000);
        } else {
            toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
        }   
      }
    },    
    attachmentSave : async function(evt) {
          evt.preventDefault()
          if (this.invalidFile) {
              console.log('validation : ', this.$v.file);
              console.log('model : ',this.file);
            //   this.showAddAttachment=true;
              toastr.error('Please choose a file');
        } else {
            toastr.info(`Attachment Save`);
            this.isLoading=true;
            try {
                const formData = new FormData();
                formData.append('file', this.file);
                formData.append('filename', this.file.name);
                formData.append('tablekey', this.terpilih.ClaimHistID);
                const response = await task.attachmentSave(formData);
                console.log('response : ',response);
                const data = await task.getAttachment({taskkey: this.terpilih.ClaimHistID});
                this.attachmens=data;    
                this.file=null;
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
            }
        }
    },   
    attachmentDownload : async function(fl) {
        this.isLoading=true;
        try {
            const response = await task.attachmentDownload(fl);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            console.log('error : ', error);
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }   
        }
    },      
    delAttachment : async function(obj) {
      const pesan=`Do You realy want to delete the attachment "${obj.attchFileNm}"?`;
      this.$bvModal.msgBoxConfirm(pesan, {
      title: 'Please Confirm',
      size: 'sm',
      buttonSize: 'sm',
      okVariant: 'success',
      okTitle: 'YES',
      cancelTitle: 'NO',
      footerClass: 'p-2',
      hideHeaderClose: false,
      centered: true
      })
      .then(async(value) => {
          if (value==true){
              this.isLoading=true;
                try {
                    await task.delAttachment(obj);
                  const data = await task.getAttachment({taskkey: this.terpilih.ClaimHistID});
                  this.attachmens=data;    
                    this.isLoading=false;    
                } catch (error) {
                    this.isLoading=false;
                    console.log('error : ', error);
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }   
                }
          }
              // this.close();
      })
      .catch(err => {
      // An error occurred
      })                

    },      

    approvalConfirm: async function () {
        if (this.terpilih.ClaimHistID) {
            if (this.terpilih.send2wf==1) {
                    try {
                      const data = await task.approvalhistory({key: this.terpilih.ClaimHistID});
                      this.approvalHistory=data;                
                    } catch (error) {
                      if (error.message) {
                          toastr.error(error.message,'ERROR MESSAGE',10000);
                      } else {
                          toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                      }                
                    }
            }
            // this.terpilih.TakenDate = this.terpilih.TakenDate ? moment(this.terpilih.TakenDate).format('YYYY-MM-DD') : '';
                this.showApprovalConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be sent to workflow Approval!');
        }
    }, 
    approval: async function(evt){
        evt.preventDefault()
        try {
            const formData = new FormData();
            if (!(this.file)) {
              if (this.confirmNoFile==false){
                toastr.info('Send without attachment, are you sure?');
                this.showConfirmNoFile=true;
                return;
              }
            } else {
              formData.append('file', this.file);
              formData.append('filename', this.file.name);
            }
            formData.append('tablekey', this.terpilih.ClaimHistID);
            this.showApprovalConfirm = false;
            this.isLoading=true;
            const resp = await benefitclaim.approval(formData);
            this.terpilih.send2wf=1;
            this.file=null;
            this.refresh();
            this.isLoading=false;
            if (resp.message) {
                toastr.warn(resp.message,'warning',10000);
            }
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    approvalUndo: async function(){
        this.isLoading=true;
        try {
            await benefitclaim.approvalUndo(this.model);
            this.terpilih.send2wf=0;
            this.showApprovalConfirm = false;
            this.refresh();
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    printApproval: async function()
    {
      if (this.terpilih.ClaimHistID) {
          this.isLoading=true;
          try {
              this.reportUrl= await task.approvalprint({key: this.terpilih.ClaimHistID});
              this.isLoading=false;
              if (this.$isMobile()){
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              } else {
                this.showReport=true;
              }
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },      
    
  }
};
</script>
